const Conclusion = () => {
    return (
        <div className="App">
            <div className="App-body conclusion">
                <h1>Conclusion</h1>
                <p>
                You sent an email to Nina's friend at the New York Times, relaying
                the critical information you had uncovered. The journalist then
                published an article using this information, and while your identity
                remained anonymous, you successfuly intitated the process of unfolding
                the truth. 
                </p>

                <p>
                As the article hit the newsstands, it sent shockwaves 
                throughout the industry and the public. Globex Corporation, 
                once a titan in its field, faced immediate and irrevocable backlash. 
                The exposé detailed not only the corruption deeply embedded 
                within the company but also shared personal stories from 
                employees who had suffered under its practices.
                </p>

                <p>
                In the wake of the publication, more employees found 
                the courage to come forward with their own concerns 
                and experiences. What began as whispers of discontent 
                grew into a chorus of voices calling for justice and 
                reform. The collective impact of their testimonies 
                further fueled the public outcry, leading to legal 
                actions and the eventual dismantling of Globex Corporation.
                </p>

                <p>
                Your role in this was crucial but unseen. From discovering Nina's 
                hidden clues to passing the torch to a trusted journalist, 
                you orchestrated the downfall of a corrupt empire from the shadows. 
                As the company crumbled, you watched from a distance, 
                knowing that your actions had helped to rectify deep-rooted wrongs.
                </p>

                <p>
                Although you remained behind the scenes, the satisfaction 
                of having set the truth free was a profound reward. Nina's 
                bravery and your determination had ignited a much-needed change, 
                ensuring that the injustices within Globex would not go unpunished. 
                The world was now watching, and thanks to you and Nina, it was a little more just.
                </p>

                <p>Thanks for playing!</p>
            </div>
        </div>
    );
  };
  
export default Conclusion;